import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateUnmatchMatch } from '../../models'

// FS-owned-modal command pattern: the FS owns the confirmation ModalDialog
// (rendering the barrel-exported MatchedStatementItemsList) and calls
// `commands.unmatch` on confirm (BHV-040).
export const useUnmatchMatchPresenter = () => {
  const intl = useProcurifyIntl()
  const { unmatchMatch, isUnmatching } = useMutateUnmatchMatch()

  const unmatch = async (matchId: number): Promise<void> => {
    try {
      await unmatchMatch({ matchId })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
      throw error
    }
  }

  return {
    commands: {
      unmatch,
    },
    states: {
      isUnmatching,
    },
  }
}
